/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/browser'

import {
  ToolbarItem as Panel,
  AssignedToResponsibilityIdentity as AssignedTo,
  SpanWithData,
} from '../'

import {
  decodeBase64
} from '../../utils'

import {
  CONTENTTYPE_FILE,
  CONTENTTYPE_EMAIL,
  CONTENTTYPE_REQUESTRUN,
} from '../../constants'


export class RequestMetaPanels extends React.PureComponent {
  static propTypes = {
    requestRunId: PropTypes.string.isRequired,
    requestType: PropTypes.string.isRequired,
    requestAssignedTo: PropTypes.shape({
      id: PropTypes.string.isRequired,
      fullName: PropTypes.string.isRequired
    }),
    requestCapturedBy: PropTypes.shape({
      fullName: PropTypes.string.isRequired
    }),
    requestValidatedBy: PropTypes.shape({
      fullName: PropTypes.string.isRequired
    }),
    requestStatus: PropTypes.string.isRequired,
    requestOrigin: PropTypes.string.isRequired,
    nextProcessingStep: PropTypes.string
  }

  state = {
    reassign: false,
    showCreateCaseModal: false,
    showStatusChangeOptions: false
  }

  closeStatusDropdownAndReset = () => (
    this.setState({ showStatusChangeOptions: false })
  )

  saveRequestAssignedTo = (requestrunMutate, assignedToIdentity) => {
    requestrunMutate({
      variables: {
        input: {
          id: this.props.requestRunId,
          assignedTo: assignedToIdentity
        }
      }
    })
    .then(() => console.log('request run updated assignedTo successfully'))
    .catch(error => Sentry.captureMessage('Identity listing pagination button state logic exception'))
  }

  getCaseRelations = (requestRunId, files) => {
    let relations = []

    if (files) {
      files.forEach(file => {
        relations.push({ objectId: decodeBase64(file.id), contentType: CONTENTTYPE_FILE })
        this.addEmailRelation(file, relations)
      })
    }
    relations.push({ objectId: decodeBase64(requestRunId), contentType: CONTENTTYPE_REQUESTRUN })

    return relations
  }

  addEmailRelation = (file, relations) => {
    if (file.relations.edges.length > 0) {
      let emailRelation = file.relations.edges.find(relation => decodeBase64(relation.node.contentType.id) === CONTENTTYPE_EMAIL.toString())
      // if file has a filerelation to an email, add caserelation to email
      if (emailRelation) {
        relations.push({ objectId: emailRelation.node.objectId, contentType: CONTENTTYPE_EMAIL })
      }
    }
  }

  render() {
    let { requestType, requestStatus, requestOrigin, requestAssignedTo, requestCapturedBy, requestValidatedBy, nextProcessingStep, requestrunMutate } = this.props

    return (
      <div id='toolbar' className='action-toolbar'>
        <Panel label='Request type' value={requestType} />
        <div className='slds-col'>
          <Panel
            label='Origin'
            value={<SpanWithData forField='RequestRunOrigin' searchKey={requestOrigin} />}
          />
        </div>
        <div className='slds-col action-toolbar__item slds-p-top_small slds-p-bottom_medium slds-p-left_small slds-p-right_small'>
          <div className='slds-grid'>
            <div className='action-toolbar__item-label slds-m-right_small' style={{ fontSize: '1em', marginBottom: 0, lineHeight: 'inherit' }}>
              Status
            </div>
            <div className={['CLOSED_CANCELLED', 'CLOSED_DUPLICATE', 'CLOSED_EXPIRED'].indexOf(requestStatus) > -1
              ? 'slds-text-color_error'
              : null
            }>
              <SpanWithData forField='RequestRunStatus' searchKey={requestStatus} />
            </div>
          </div>
          <div className='slds-grid slds-m-top_x-small'>
            <div className='action-toolbar__item-label slds-m-right_small' style={{ fontSize: '1em', marginBottom: 0, lineHeight: 'inherit' }}>
              Next step
            </div>
            <div className='titlecase'>
              {nextProcessingStep}
            </div>
          </div>
        </div>
        {requestAssignedTo !== undefined &&
          <AssignedTo
            identityId={requestAssignedTo && requestAssignedTo.id}
            firstName={requestAssignedTo && requestAssignedTo.firstName}
            lastName={requestAssignedTo && requestAssignedTo.lastName}
            responsibility='handle_requests'
            assignedToSave={identityId => {
              this.setState({ reassign: false })
              this.saveRequestAssignedTo(requestrunMutate, identityId)
            }}
            dropdownOpen={this.state.reassign}
            closeDropdown={() => this.setState({ reassign: false })}
            onClick={() => this.setState({ reassign: true })}
          />
        }
        <div className='slds-col'>
          <Panel
            label='Captured by'
            value={requestCapturedBy
              ? requestCapturedBy.fullName
              : '-'
            }
          />
        </div>
        <div className='slds-col'>
          <Panel
            label='Validated by'
            value={requestValidatedBy
              ? requestValidatedBy.fullName
              : '-'
            }
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/request-meta-panels/index.js